import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LocalStorageService, UserService} from '../../../../../_services';
import {ChooseEmotionComponent} from '../choose-emotion/choose-emotion.component';
import {ModalController} from '@ionic/angular';
import {LoadingService} from '../../../../../_services/loading.service';
import {environment} from '../../../../../../environments/environment';
import {MultipleChoiceOptions, SurveyModel, UserDetailsQuestions} from './survey.model';
import {TermsAndConditionComponent} from '../../../../../components/terms-condition/terms-condition.component';
import {Location} from '@angular/common';
import {ReportPublishedComponent} from '../report-published/report-published.component';
import {CommonService} from '../../../../../_services/common.service';

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss',
    '../add-report/add-report.component.scss',
    '../../../../admin/admin-console/admin-console.component.scss']
})
export class SurveyComponent {
  report: any;
  progressBarValue = 0;
  pageIndex = 1;
  emotions: any = [];
  emotionList: any = [];
  profileImage = '';
  image = '';
  serverUrl = environment.server + '/public';
  emotionSelectorPlaceholderText = 'Choose up to 3 emotions';
  projectSurvey: any [] = [];
  userDetailsQuestions: any [] = [];
  emotionReport: any = [];
  surveyModelObj: SurveyModel = {};
  multipleChoiceModelObj: MultipleChoiceOptions = {};
  userDetailsObj: UserDetailsQuestions = {};
  totalPages = 1;
  tnc = false;
  otherQuestions: any;
  projectName = '';
  projectObj: any;

  constructor(private activatedRoute: ActivatedRoute,
              public loadingService: LoadingService,
              public modalController: ModalController,
              private commonService: CommonService,
              private localStorageService: LocalStorageService,
              private location: Location,
              private userService: UserService,) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.report = params;
      this.projectObj = this.commonService.getProjectDetails(this.report.projectType);
      console.log(this.projectObj);
      if (this.report.projectType) {
        this.getSurvey();
      }
    });
    this.projectName = this.localStorageService.get('selected_project')?.name;
  }

  getSurvey() {
    this.userService.getSurvey(this.report.projectType)
      .subscribe({
        next: (value) => {
          this.projectSurvey = value.survey;
          this.userDetailsQuestions = value.projectSurvey[0]?.userDetailsQuestions.filter(obj => obj.isRequired);
          this.otherQuestions = value.projectSurvey[0];
          this.progressBarValue = this.pageIndex / (value.survey.length + 2);
          this.totalPages = value.survey.length + 2;
          console.log(this.otherQuestions);
        }
      });
  }

  async chooseEmotion() {
    const modal = await this.modalController.create({
      component: ChooseEmotionComponent,
      componentProps: {
        parentEmotions: this.emotions,
        maxEmotions: 3,
        addReport: true
      },
      cssClass: 'custom-modal',
      showBackdrop: true,
      backdropDismiss: true,
    });
    modal.onDidDismiss()
      .then((data) => {
        if (data.data) {
          this.emotions = data.data;
          if (this.emotions.length > 0) {
            this.emotionList = [];
            this.emotions.forEach(emotionObj => {
              this.emotionList.push(emotionObj.name);
            });

            if (this.emotions.length === 1) {
              this.emotionSelectorPlaceholderText = this.emotions.length + ' emotion selected';
            } else {
              this.emotionSelectorPlaceholderText = this.emotions.length + ' emotions selected';
            }
          }
        }
      });
    return await modal.present();
  }

  back() {
    if (this.pageIndex === 1) {
      this.location.back();
    }
    this.pageIndex--;
    this.progressBarValue = this.pageIndex / (this.projectSurvey.length + 2);
  }

  fileUploading($event: any) {
    this.loadingService.show();
  }

  onFileUploadDone(image: any) {
    this.loadingService.hide();
    this.profileImage = this.serverUrl + '/upload/' + image.filename;
    this.image = '/upload/' + image.filename;
  }

  onFileUploadError($event: any) {

  }

  addMoreInfo() {
    // if (this.pageIndex >1) {
    if (this.pageIndex < this.totalPages - 1) {
      if (!this.emotionReport.hasOwnProperty('answers')) {
        this.emotionReport.answers = [];
      }
      const questionModel = Object.assign({}, this.surveyModelObj);
      questionModel.question = this.projectSurvey[this.pageIndex - 1].question;
      questionModel.answer = '';
      if (this.projectSurvey[this.pageIndex - 1].type === 'Multiple choice') {
        questionModel.multipleChoiceOptions = [];
        const multiQuestions = this.projectSurvey[this.pageIndex - 1].multipleChoiceOptions.length;
        let count = 0;
        while (count < multiQuestions) {
          const question = this.projectSurvey[this.pageIndex - 1].multipleChoiceOptions[count].question;
          const multipleChoiceModel = Object.assign({}
            , this.multipleChoiceModelObj);
          multipleChoiceModel.question = question;
          questionModel.multipleChoiceOptions.push(multipleChoiceModel);
          count++;
        }
      }
      this.emotionReport.answers.push(questionModel);
    } else if (this.pageIndex === this.totalPages - 1) {
      this.emotionReport.userDetailsObj = {
        email: '',
        age: '',
        gender: '',
        genderDetails: '',
        firstLanguageDetails: '',
        identifyDetails: '',
        postCode: '',
        occupation: '',
        firstLanguage: '',
        identify: ''
      };
    }
    this.pageIndex++;
    this.progressBarValue = this.pageIndex / (this.projectSurvey.length + 2);
  }

  completeReport(pageIndex: number) {
  }

  async terms() {
    const modal = await this.modalController.create({
      component: TermsAndConditionComponent,
      componentProps: {
        report: this.report
      },
      cssClass: 'custom-modal',
      showBackdrop: true,
      backdropDismiss: true,
    });
    return await modal.present();
  }

  publish() {
    this.emotionReport.title = this.report.title;
    this.emotionReport.location = this.report.location;
    this.emotionReport.projectType = this.report.projectType;
    this.emotionReport.image = this.image;
    const reportObj: any = {
      emotions: this.emotionList,
      title: this.report.title,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      location_name: this.emotionReport.location_name ? this.emotionReport.location_name : this.report.title,
      location: this.report.location,
      projectType: this.report.projectType,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      user_details: this.emotionReport.userDetailsObj,
      answers: this.emotionReport.answers,
      image: this.image,
      reportType: this.report.type ? this.report.type : '',
      // eslint-disable-next-line no-underscore-dangle
      projectId: this.projectObj._id
    };
    // eslint-disable-next-line no-underscore-dangle
    this.userService.createEmotionReport(reportObj)
      .subscribe((data) => {
        this.reportPublished(data);
      }, (error) => {
        console.error(error, 'error');
      });
  }

  async reportPublished(data) {
    this.localStorageService.set('report_created', true);
    this.progressBarValue = 1;
    const modal = await this.modalController.create({
      component: ReportPublishedComponent,
      componentProps: {
        report: data
      },
      cssClass: 'pop-up-modal-large',
      showBackdrop: true,
      backdropDismiss: false,
    });
    return await modal.present();
  }

  setState() {
    if (this.userDetailsQuestions && this.userDetailsQuestions.length > 0) {
      const mandatoryFields = this.userDetailsQuestions.filter(obj => obj.isMandatory);
      const value = mandatoryFields.map((obj: any) => this.emotionReport.userDetailsObj[obj.question] !== '');
      return value.every(Boolean);
    } else {
      return true;
    }
  }

  setInfoState(survey: any, index: number) {
    if (survey.isMandatory && survey.type !== 'Multiple choice') {
      return !!this.emotionReport.answers[index].answer;
    }
    if (survey.isMandatory && survey.type === 'Multiple choice') {
      return this.emotionReport.answers[index].multipleChoiceOptions.findIndex((obj: any) => obj.answer === true) > -1;
    }
    return true;
  }
}
